const bus = {
    listeners: {},
    on: function (eventName, callback) {
        if (this.listeners[eventName]) {
            this.listeners[eventName].push(callback);
        } else {
            this.listeners[eventName] = [callback];
        }
    },
    off: function (eventName, callback) {
        if (this.listeners[eventName]) {
            for (let i = 0; i < this.listeners[eventName].length; i++) {
                if (this.listeners[eventName][i] === callback) {
                    this.listeners[eventName].splice(i, 1);
                    break;
                }
            }
            if (this.listeners[eventName].length === 0) {
                this.listeners[eventName] = undefined;
            }
        }
    },
    emit: function (eventName, args) {
        if (this.listeners[eventName]) {
            for (let i = 0; i < this.listeners[eventName].length; i++) {
                this.listeners[eventName][i](args);
            }
        }
    }
};

export default bus;



// WEBPACK FOOTER //
// ./src/bus.js